// wishlist and compare counts
function updateCartCounts($this) {
    const whichList = $this.data("whichlist");
    const productID = $this.data("productid");
    // REVIEW if isChecked is not used, consider removing it
    // eslint-disable-next-line no-unused-vars
    const isChecked = $this.data("checked");
    const rNumber = 1 + Math.floor(Math.random() * 100000);
    const rLinkAdd = `?jq=${rNumber}`;
    let addOrRemove = "";
    let titleString = "";
    let replacedString = "";
    // cross browser support for checking checked status
    if (whichList === "wishlist") {
        if ($this.data("checked") == 0) {
            addOrRemove = "add";
            $this.data("checked", "1");
            document.getElementById(`icon_${productID}`).className = "fa fa-check fa-lg";
            document.getElementById(`icon2_${productID}`).className = "fa fa-check fa-lg";
            if ($(`#wishListAdd_${productID}`).length) {
                titleString = document.getElementById(`wishListAdd_${productID}`).title;
                replacedString = titleString.replace("Custom Add to", "Update in");
                document.getElementById(`wishListAdd_${productID}`).title = replacedString;
            }
        } else {
            addOrRemove = "remove";
            $this.data("checked", "0");
            document.getElementById(`icon_${productID}`).className = "fa fa-heart fa-lg";
            document.getElementById(`icon2_${productID}`).className = "fa fa-heart fa-lg";
            if ($(`#wishListAdd_${productID}`).length) {
                titleString = document.getElementById(`wishListAdd_${productID}`).title;
                replacedString = titleString.replace("Update in ", "Custom Add to ");
                document.getElementById(`wishListAdd_${productID}`).title = replacedString;
            }
        }
    }
    // TODO return JSON success result
    // eslint-disable-next-line max-len
    $.get(`/Products/setSessionValues.cfm${rLinkAdd}&whichOne=${whichList}&addOrRemove=${addOrRemove}&productID=${productID}`).then(() => {
        $.get(`/Products/wishListStats.cfm${rLinkAdd}`, (countString) => {
            const countArr = countString.split(",");
            const cartCount = countArr[0];
            console.log(countArr);
            $("#cartCount").text(cartCount);
            $("#cartCount1").text(cartCount);
            $("#cartCount2").text(cartCount);
        });
    });
}

// wishlist and compare check / uncheck
$(() => {
    // checkbox from search Page
    $("a.checkAddRemove").click(function () {
        updateCartCounts($(this));
    });
    $("a.wlLocked").click(() => {
        alert("This item cannot be added because your wish list is locked!");
    });
});
